import { render, staticRenderFns } from "./CreateSageDepartmentsPopUp.vue?vue&type=template&id=e9a244ee&scoped=true&"
import script from "./CreateSageDepartmentsPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateSageDepartmentsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateSageDepartmentsPopUp.vue?vue&type=style&index=0&id=e9a244ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a244ee",
  null
  
)

export default component.exports